<section class="wrapper">
  <header class="row">
    <h1 i18n>Register new REST API client</h1>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <span i18n>Here we will register a new REST API client.</span>

      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="accountSearch" i18n>User associated with the API requests:</label>
          <mat-form-field>
            <input
              matInput
              [formControl]="userSearchControl"
              [matAutocomplete]="auto"
              placeholder="Search for user profiles"
              i18n-placeholder>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="onUserSelected($event.option.value)">
              @for (userProfile of filteredUsers$ | async; track userProfile) {
                <mat-option [value]="userProfile">
                  {{ userProfile.firstName }} {{ userProfile.lastName }} ({{ userProfile.email }})
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <button type="submit" class="btn btn-primary" i18n>Proceed</button>
      </form>
    </div>
  </div>
</section>
